<template>
    <div class="provider-wrapper">
        <span class="provider-message">
            Select which doctor wants to call {{ this.patient.name }}
        </span>
        <span  v-for="(providerObj, index) in providerProfileList"
            :key="index"
            @click="$emit('provider-select', providerObj)"
            class="provider-choice">
            <b>{{ getProviderNameById(providerObj.provider)}}</b> ({{ getContentKey('profile', providerObj.profile, 'title') }})
        </span>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
/**
 * Select providers for calling for video call
 */
export default {
    name: 'call-select',

    props: {
        patient: {
            type: Object,
            required: true
        },
        providerProfileList: {
            type: Array,
            required: true,
            default: () => []
        }
    },

    computed: {
        ...mapGetters('content', [
            'getContentKey'
        ]),
        ...mapGetters('provider', [
            'getProviderNameById',
        ])
    }
}
</script>

<style lang="scss" scoped>
@import "@/module/app/theme/color.scss";

.provider-wrapper {
    display: flex;
    flex-direction: column;
    word-break: normal;
    font-size: 14px;
    span.provider-choice {
        padding: 9px 12px 7px 16px;
        cursor: pointer;
        color: $grey-700;
        text-align: left;
        b {
            color: $black-color;
        }
    }
    span.provider-choice:hover {
        background-color: $grey-000;
    }
    span.provider-message {
        font-size: 12px;
        padding: 12px 20px 8px 16px;
        color: $grey-700;
        border-bottom: 1px solid $grey-100;
        text-align: left;

    }

}
</style>
